import './emblemChooser.less';

import axios from 'axios';
import Paths from '../../../dev/js/core/Helpers/Paths';


const emblemChooser = props => {
    let headerBox = document.getElementById('js-chooser-header');
    let introBox = document.getElementById('js-chooser-intro');
    let imgBox = document.getElementById('js-chooser-img');
    
    const insertEmblem = (e, input, component, btn) => {
        input.value = e.currentTarget.dataset.id;
        let chosenBox = component.getElementsByClassName('js-chosen-one')[0];
        let removeBtn = component.getElementsByClassName('js-remove-emblem')[0];
        
        Array.from(document.getElementsByClassName('closable')).map( modal => modal.classList.remove('opened'));
        
        !chosenBox.classList.contains('active')
            ? chosenBox.classList.add('active')
            : null;
        
        
        let chosen = document.getElementById(component.getAttribute('id') + '-price');
        let chosenImg = document.getElementById(component.getAttribute('id') + '-cover');
        
        btn.innerText = btn.dataset.change;
        chosen.innerText = e.currentTarget.dataset.price;
        chosen.dataset.price = e.currentTarget.dataset.price;
        chosenImg.src = e.currentTarget.dataset.src;
        props.updatePrice();
    
        removeBtn.addEventListener('click', () => {
            input.value = '';
            chosen.innerText = '';
            chosen.dataset.price = 0;
            btn.innerText = btn.dataset.original;
            chosenBox.classList.remove('active');
            props.updatePrice();
        });
    };
    
    const addListeners = (input, component, btn) => {
        let emblemBoxes = document.getElementsByClassName('js-emblem-box');
        [...emblemBoxes].map( close => close.addEventListener('click', e => insertEmblem(e, input, component, btn)));
    };
    
    
    const getTemplate = product => {
        
        return `<div class="flex-xs-6 flex-mxs-4 flex-sm-4 flex-md-3 text-center nopadding flex-column">
		
		<div
		    class="emblem-box text-center js-emblem-box"
            data-src="${product.Image}"
            data-price="${product.CenaSprzedazy}"
            data-id="${product.IDWariantu}"
            data-box="emblem-${product.IDProduktu}">
			<img loading="lazy" class="emblem-box__img" src="${product.Image}" alt="Name">
			<div class="emblem-box__price">${product.CenaSprzedazy}</div>
		</div>
	    </div>`;
     
    };
    
    const getEmblems = e => {
      //  let box = e.currentTarget.parentElement;
        let box = e.currentTarget.closest('.emblemChooser');
        let btn = e.currentTarget;
        let injectable = document.getElementById('emblem-injectable');
        let input = box.getElementsByClassName('emblemValue')[0];
        let set = box.dataset.itemset;

        
        let emblems = axios.get(`get-accessories-set,${set}.json`, {
	        headers: {
	            'Pragma' : 'no-cache',
                'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0, post-check=0, pre-check=0',
	        }
        });
    
        emblems.then(response => {
            injectable.innerHTML = '';
            response.data.products.map(product => {
                injectable.insertAdjacentHTML('beforeend', getTemplate(product))
            });
            
            headerBox.innerText = response.data.accessoriesSet.header;
            introBox.innerText = response.data.accessoriesSet.description;
            imgBox.src = response.data.accessoriesSet.image;
            
            addListeners(input, box, btn);
        });
        
        
        document.querySelector('#js-choose-emblem-wrapper').classList.toggle('opened');
    };
    
    let chooserBtns = document.getElementsByClassName('js-choose-emblem');
    [...chooserBtns].map(btn => btn.addEventListener('click', e => getEmblems(e) ));

    
};

export default emblemChooser;


// WEBPACK FOOTER //
// ./components/emblemChooser/emblemChooser.js